module.exports = __webpack_public_path__ + "static/media/tw.8a194685.svg";